import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { number, params, shape, string, arrayOf } from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { usePIPRedirectRules } from './rules/pip-redirect-rules';
import { getPathWithMergedParams } from './Redirector';


const ssrDefault = typeof window === 'undefined';

export const PIPRedirector = ({ ssr = ssrDefault, disablePEPRedirect }) => {

  if (!ssr) return null;

  const { pathWithQueryParams, itemId, redirectState, bypass } = useContext(RedirectContext);

  if (bypass) {
    redirectState.redirect = false;
    return null;
  }
  const [path, queryParams] = pathWithQueryParams.split('?');
  const redirectRules = usePIPRedirectRules({ path, queryParams, itemId, disablePEPRedirect });
  const { shouldRedirect = false, redirectPath = '', httpCode = 200, isErrorStatus = false } = redirectRules;

  if (shouldRedirect || isErrorStatus) {
    const fullRedirectPath = queryParams ? `${getPathWithMergedParams(redirectPath, queryParams)}` : redirectPath;
    redirectState.redirect = shouldRedirect;
    redirectState.url = fullRedirectPath;
    redirectState.code = httpCode;
    redirectState.isErrorStatus = isErrorStatus;
  }

  return null;
};

PIPRedirector.propTypes = {
  ssr: PropTypes.bool,
  disablePEPRedirect: PropTypes.bool
};

PIPRedirector.defaultProps = {
  ssr: ssrDefault,
  disablePEPRedirect: false
};

PIPRedirector.dataModel = {
  product: params({ itemId: string() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
